const moment = require('moment');
import { ILogEntry } from 'motw_core/Entity/ILogEntry';
import UI from 'source/app/services/UI/UI';

export interface IMappedMonumentalRecord {
	simpleDate: string;
	verbSymbol: string;
	tooltip: string;
}

export function GetMappedMonumentalRecords(log: ILogEntry[]) {
	const result = log
		.filter((logEntry) => logEntry.kips > 0 && logEntry.significance == 3)
		.map(
			(logEntry) =>
				({
					simpleDate: moment(logEntry.lastmodifiedtime)
						.local()
						.format('YYYY-MM-DD'),
					verbSymbol: UI.GetEventCategory(logEntry.entry),
					tooltip: logEntry.entry.split(' ').splice(1).join(' ')
				} as IMappedMonumentalRecord)
		);
	return result;
}
